import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import "./assets/css/animate.css";
import "./assets/css/style.css";
import './assets/css/Header.css';
import 'aos/dist/aos.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import AOS from 'aos';
import 'animate.css';

import Header from "./components/Header";

import Footer from './components/Footer';
import Home from './components/Home'; 


//import ImageCarousel from './components/ImageCarousel';
// import AboutSection from './components/AboutSection';
// import Commitment from './components/Commitment';
// import VisionMission from './components/VisionMission';
// import ManagementSection from './components/ManagementSection'
import ChairmanSection from './components/ChairmanSection'
import SecretarySection from './components/SecretarySection'
import FounderSection from './components/FounderSection'
import PrincipalDesk from './components/PrincipalDesk'


import Admission from './components/AdmissionSection'
import FacultySection from './components/FacultySection'
import AdministrativeSection from './components/AdministrativeSection'
import Library from './components/Library'
import UniqueFeatures from './components/UniqueFeatures'
import ScienceLab from './components/ScienceLab'


import ComputerLab from "./components/ComputerLab"

import Transportation from "./components/Transportation"
import Classrooms from "./components/Classrooms"

import ICL from "./components/ICL"

import Scholarships from "./components/Scholarships";
import ValueAddedProgrammes from "./components/ValueAddedProgrammes"

import GuidenceSection from "./components/GuidenceSection";
import UpcomingEvents from "./components/UpcomingEvents";
import Gallery from "./components/Gallery";
import ContactUs from "./components/ContactUs";
import WhatsAppIcon from './components/WhatsAppIcon'; 
// Lazy load components
const ImageCarousel = lazy(() => import("./components/ImageCarousel"));
const AboutSection = lazy(() => import("./components/AboutSection"));
const Commitment = lazy(() => import("./components/Commitment"));
const VisionMission = lazy(() => import("./components/VisionMission"));
const ManagementSection = lazy(() => import("./components/ManagementSection"));

AOS.init();
const fadeInUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const LazyComponent = ({ Component }) => {
  const { ref, inView } = useInView({
    triggerOnce: false, // Set to false for repeated animations
    threshold: 0.1, // Adjust for better visibility
  });

  return (
    <div ref={ref} className="mb-10">
      <Suspense fallback={<div className="text-center p-4">Loading...</div>}>
        <motion.div
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          exit="hidden"
          variants={fadeInUp}
        >
          <Component />
        </motion.div>
      </Suspense>
    </div>
  );
};


function App() {
  return (
    <Router>
      <Header/>
      <Routes>
        <Route path="/" element={<Home />}>
          {/* <Route index element={<div>  <ImageCarousel /><AboutSection /><Commitment /><VisionMission /><ManagementSection /></div>} />  */}
          <Route
      index
      element={
        <div>
          <LazyComponent Component={ImageCarousel} />
          <LazyComponent Component={AboutSection} />
          <LazyComponent Component={Commitment} />
          <LazyComponent Component={VisionMission} />
          <LazyComponent Component={ManagementSection} />
        </div>
      }
    />
          <Route path="aboutSection" element={<AboutSection />} />
          <Route path="commitment" element={<Commitment />} />
          <Route path="visionMission" element={<VisionMission />} />
          <Route path="management" element={<ManagementSection />} />
          <Route path="chairmanMessage" element={<ChairmanSection />} />
          <Route path="secretaryMessage" element={<SecretarySection />} /> 
          <Route path="founder" element={<FounderSection />} /> 
          <Route path="principalDesk" element={<PrincipalDesk />} /> 
       
          <Route path="admission" element={<Admission />} /> 
          <Route path="UniqueFeatures" element={<UniqueFeatures />} />
          <Route path="administration" element={<AdministrativeSection />} />
          <Route path="library" element={<Library />} />
          <Route path="faculty" element={<FacultySection />} />
          <Route path="scienceLab" element={<ScienceLab />} />
         <Route path="transportation" element={<Transportation />} />
     
          <Route path="computerLab" element={<ComputerLab />} />
          <Route path="classrooms" element={<Classrooms />} />
     
          <Route path="icl" element={<ICL />} />
          
          
          <Route path="scholarships" element={<Scholarships />} />
          <Route path="valueAddedPrograms" element={<ValueAddedProgrammes />} />
          <Route path="guidence" element={<GuidenceSection/>}/>
          <Route path="upcomingEvents" element={<UpcomingEvents />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="contact" element={<ContactUs />} />
       
          
          {/* Add other routes if needed */}
        </Route>
      </Routes>
      <WhatsAppIcon phoneNumber="919524550357" /> {/* College WhatsApp number */}
     
      <Footer />
    </Router>
  );
}

export default App;
